import * as React from 'react';

import { getStoreState, subscribeToStoreState } from '../state/Store';

export default class<T, S = {}> extends React.Component<T, S> {
  unsubscribe: Function;
  isRecording: boolean | undefined;
  animationFrameReq: number;

  componentDidMount() {
    this.unsubscribe = subscribeToStoreState(this.storeDidUpdate);
    this.isRecording = undefined;
    this.animationFrameReq = -1;

    this.storeDidUpdate();
  }
  storeDidUpdate = () => {
    const newIsRecording = getStoreState().app.recorder !== null;
    if (newIsRecording !== this.isRecording) {
      this.isRecording = newIsRecording;
      if (!this.isRecording) {
        this.animationFrameReq = requestAnimationFrame(this.animate);
      } else {
        cancelAnimationFrame(this.animationFrameReq);
        this.animationFrameReq = -1;
      }
    }
  };
  componentWillUnmount() {
    this.unsubscribe();
    if (this.animationFrameReq !== -1) {
      cancelAnimationFrame(this.animationFrameReq);
      this.animationFrameReq = -1;
    }
  }
  animate = () => {
    this.tick();

    this.animationFrameReq = requestAnimationFrame(this.animate);
  };
  tick() {
    // override
  }
}



// WEBPACK FOOTER //
// ./src/components/LiveComponent.ts